import React, { useState, useEffect } from 'react';
import './PrintPreviewModal.css';

const PrintPreviewModal = ({ isOpen, onClose, printData, onPrint }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [orientation, setOrientation] = useState('landscape'); // 기본값: landscape

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handlePrint = () => {
    setIsLoading(true);
    
    // Create a new window for printing
    const printWindow = window.open('', '_blank', 'width=920,height=640,scrollbars=yes,resizable=yes');
    
    if (printWindow) {
      const printHTML = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
          <title>지방출력 | 파라다이스 추모원</title>
          <style>
            @page {
              size: A4 ${orientation};
              margin: 0.4in 0.15in 0.4in 0.25in;
            }
            @media print {
              body { 
                margin: 0;
                padding: 0;
                width: 100%;
                height: 100%;
                overflow: hidden;
              }
              .no-print { display: none !important; }
              * {
                page-break-inside: avoid;
                page-break-after: avoid;
              }
              div[style*="float:left"] {
                page-break-inside: avoid;
                page-break-after: avoid;
              }
            }
          </style>
        </head>
        <body bgcolor="#FFFFFF" text="#000000" leftmargin="0" topmargin="0" marginwidth="0" marginheight="0" align="center">
          <div style="width:100%; height:100%; text-align:center; page-break-inside:avoid; overflow:hidden; padding-left:5px;">
            ${generateTablets(printData.goin, printData.positionHanja, printData.lastnameHanja)}
          </div>
          <script>
            window.onload = function() {
              window.print();
              window.onafterprint = function() {
                window.close();
              };
            };
          </script>
        </body>
        </html>
      `;

      printWindow.document.write(printHTML);
      printWindow.document.close();
      
      // Close the preview modal after printing
      setTimeout(() => {
        setIsLoading(false);
        onClose();
      }, 1000);
    } else {
      setIsLoading(false);
      alert('팝업이 차단되었습니다. 팝업을 허용해주세요.');
    }
  };

  const generateTablets = (goin, position, lastname) => {
    let tabletsHTML = '';

    // Generate 5 tablets
    for (let i = 0; i < 5; i++) {
      tabletsHTML += `
        <div style="float:left; margin:0 1px 0 0; position:relative; font-family:'바탕체';width:148px; height:580px;">
          <img src="https://www.prds.kr/images/popup_jibang_bg.png" style="position:absolute; top:0; left:0; width:148px; height:580px;" />
          <div style="position:absolute; top:0; left:0; font-size:42px;font-family:'바탕체'; width:148px; height:580px;">
            ${generateTabletContent(goin, position, lastname)}
          </div>
        </div>
      `;
    }

    return tabletsHTML;
  };

  const generateTabletContent = (goin, position, lastname) => {
    // Exact logic for generating tablet content with conditional line breaks
    const hasLastName = lastname && lastname.trim() !== '';
    const femaleNameBreaks = hasLastName ? '' : '<br><br><br><br>';
    
    if (goin === '0|1') { // 고조부모
      return `
        <div style="position:absolute; top:25px; left:26px;font-family:'바탕체'; width:39px;  line-height:55px;">顯高祖考${position}府君</div>
        <div style="position:absolute; top:29px; left:82px;font-family:'바탕체'; width:39px;  line-height:45px;">顯高祖妣孺人${femaleNameBreaks}${lastname}氏</div>
        <div style="position:absolute; top:474px; left:26px;font-family:'바탕체'; width:30px; line-height:46px;">神位</div>
        <div style="position:absolute; top:474px; left:82px;font-family:'바탕체'; width:30px; line-height:46px;">神位</div>
      `;
    } else if (goin === '0') { // 고조부
      return `
        <div style="position:absolute; top:19px; left:52px;font-family:'바탕체'; width:39px;  line-height:55px;">顯高祖考${position}府君</div>
        <div style="position:absolute; top:469px; left:52px;font-family:'바탕체'; width:30px; line-height:55px;">神位</div>
      `;
    } else if (goin === '1') { // 고조모
      return `
        <div style="position:absolute; top:19px; left:52px;font-family:'바탕체'; width:39px;  line-height:46.0px;">顯高祖妣孺人${femaleNameBreaks}${lastname}氏</div>
        <div style="position:absolute; top:474px; left:52px;font-family:'바탕체'; width:30px; line-height:46px;">神位</div>
      `;
    } else if (goin === '2|3') { // 증조부모
      return `
        <div style="position:absolute; top:25px; left:26px;font-family:'바탕체'; width:39px;  line-height:50px;">顯曾祖考${position}府君</div>
        <div style="position:absolute; top:29px; left:82px;font-family:'바탕체'; width:39px;  line-height:45px;">顯曾祖妣孺人${femaleNameBreaks}${lastname}氏</div>
        <div style="position:absolute; top:474px; left:26px;font-family:'바탕체'; width:30px; line-height:50px;">神位</div>
        <div style="position:absolute; top:474px; left:82px;font-family:'바탕체'; width:30px; line-height:50px;">神位</div>
      `;
    } else if (goin === '2') { // 증조부
      return `
        <div style="position:absolute; top:19px; left:52px;font-family:'바탕체'; width:39px;  line-height:55px;">顯曾祖考${position}府君</div>
        <div style="position:absolute; top:460px; left:52px;font-family:'바탕체'; width:30px; line-height:55px;">神位</div>
      `;
    } else if (goin === '3') { // 증조모
      return `
        <div style="position:absolute; top:19px; left:52px;font-family:'바탕체'; width:39px;  line-height:45px;">顯曾祖妣孺人${femaleNameBreaks}${lastname}氏</div>
        <div style="position:absolute; top:469px; left:52px;font-family:'바탕체'; width:30px; line-height:45px;">神位</div>
      `;
    } else if (goin === '4|5') { // 조부모
      return `
        <div style="position:absolute; top:25px; left:26px;font-family:'바탕체'; width:39px;  line-height:60px;">顯祖考${position}府君</div>
        <div style="position:absolute; top:29px; left:82px;font-family:'바탕체'; width:39px;  line-height:50px;">顯祖妣孺人${femaleNameBreaks}${lastname}氏</div>
        <div style="position:absolute; top:474px; left:26px;font-family:'바탕체'; width:30px; line-height:50px;">神位</div>
        <div style="position:absolute; top:474px; left:82px;font-family:'바탕체'; width:30px; line-height:50px;">神位</div>
      `;
    } else if (goin === '4') { // 조부
      return `
        <div style="position:absolute; top:19px; left:52px;font-family:'바탕체'; width:39px;  line-height:60px;">顯祖考${position}府君</div>
        <div style="position:absolute; top:450px; left:52px;font-family:'바탕체'; width:30px; line-height:60px;">神位</div>
      `;
    } else if (goin === '5') { // 조모
      return `
        <div style="position:absolute; top:19px; left:52px;font-family:'바탕체'; width:39px;  line-height:50px;">顯祖妣孺人${femaleNameBreaks}${lastname}氏</div>
        <div style="position:absolute; top:464px; left:52px;font-family:'바탕체'; width:30px; line-height:50px;">神位</div>
      `;
    } else if (goin === '6|7') { // 백부모
      return `
        <div style="position:absolute; top:25px; left:26px;font-family:'바탕체'; width:39px;  line-height:60px;">顯伯父${position}府君</div>
        <div style="position:absolute; top:29px; left:82px;font-family:'바탕체'; width:39px;  line-height:50px;">顯伯母孺人${femaleNameBreaks}${lastname}氏</div>
        <div style="position:absolute; top:469px; left:26px;font-family:'바탕체'; width:30px; line-height:50px;">神位</div>
        <div style="position:absolute; top:469px; left:82px;font-family:'바탕체'; width:30px; line-height:50px;">神位</div>
      `;
    } else if (goin === '6') { // 백부
      return `
        <div style="position:absolute; top:19px; left:52px;font-family:'바탕체'; width:39px;  line-height:60px;">顯伯父${position}府君</div>
        <div style="position:absolute; top:450px; left:52px;font-family:'바탕체'; width:30px; line-height:60px;">神位</div>
      `;
    } else if (goin === '7') { // 백모
      return `
        <div style="position:absolute; top:19px; left:52px;font-family:'바탕체'; width:39px;  line-height:50px;">顯伯母孺人${femaleNameBreaks}${lastname}氏</div>
        <div style="position:absolute; top:469px; left:52px;font-family:'바탕체'; width:30px; line-height:50px;">神位</div>
      `;
    } else if (goin === '8|9') { // 부모
      return `
        <div style="position:absolute; top:25px; left:26px;font-family:'바탕체'; width:39px;  line-height:65px;">顯考${position}府君</div>
        <div style="position:absolute; top:29px; left:82px;font-family:'바탕체'; width:39px;  line-height:55px;">顯妣孺人${femaleNameBreaks}${lastname}氏</div>
        <div style="position:absolute; top:469px; left:26px;font-family:'바탕체'; width:30px; line-height:50px;">神位</div>
        <div style="position:absolute; top:469px; left:82px;font-family:'바탕체'; width:30px; line-height:50px;">神位</div>
      `;
    } else if (goin === '8') { // 부
      return `
        <div style="position:absolute; top:19px; left:52px;font-family:'바탕체'; width:39px;  line-height:65px;">顯考${position}府君</div>
        <div style="position:absolute; top:440px; left:52px;font-family:'바탕체'; width:30px; line-height:65px;">神位</div>
      `;
    } else if (goin === '9') { // 모
      return `
        <div style="position:absolute; top:19px; left:52px;font-family:'바탕체'; width:39px;  line-height:55px;">顯妣孺人${femaleNameBreaks}${lastname}氏</div>
        <div style="position:absolute; top:460px; left:52px;font-family:'바탕체'; width:30px; line-height:55px;">神位</div>
      `;
    } else if (goin === '11') { // 남편
      return `
        <div style="position:absolute; top:19px; left:52px;font-family:'바탕체'; width:39px;  line-height:65px;">顯辟${position}府君</div>
        <div style="position:absolute; top:440px; left:52px;font-family:'바탕체'; width:30px; line-height:65px;">神位</div>
      `;
    } else if (goin === '10') { // 처
      return `
        <div style="position:absolute; top:19px; left:52px;font-family:'바탕체'; width:39px;  line-height:55px;">亡室孺人${femaleNameBreaks}${lastname}氏</div>
        <div style="position:absolute; top:450px; left:52px;font-family:'바탕체'; width:30px; line-height:55px;">神位</div>
      `;
    } else if (goin === '15') { // 형
      return `
        <div style="position:absolute; top:19px; left:52px;font-family:'바탕체'; width:39px;  line-height:65px;">顯兄${position}府君</div>
        <div style="position:absolute; top:440px; left:52px;font-family:'바탕체'; width:30px; line-height:65px;">神位</div>
      `;
    } else if (goin === '14') { // 형수
      return `
        <div style="position:absolute; top:19px; left:52px;font-family:'바탕체'; width:39px;  line-height:50px;">顯兄嫂孺人${femaleNameBreaks}${lastname}氏</div>
        <div style="position:absolute; top:469px; left:52px;font-family:'바탕체'; width:30px; line-height:50px;">神位</div>
      `;
    } else if (goin === '13') { // 동생
      return `
        <div style="position:absolute; top:19px; left:52px;font-family:'바탕체'; width:39px;  line-height:65px;">亡弟${position}府君</div>
        <div style="position:absolute; top:440px; left:52px;font-family:'바탕체'; width:30px; line-height:65px;">神位</div>
      `;
    } else if (goin === '12') { // 제수
      return `
        <div style="position:absolute; top:19px; left:52px;font-family:'바탕체'; width:39px;  line-height:50px;">亡弟嫂孺人${femaleNameBreaks}${lastname}氏</div>
        <div style="position:absolute; top:464px; left:52px;font-family:'바탕체'; width:30px; line-height:50px;">神位</div>
      `;
    }

    return '';
  };

  if (!isOpen) return null;

  return (
    <div className="print-preview-modal-overlay">
      <div className="print-preview-modal">
        <div className="print-preview-header">
          <h2>지방 출력 미리보기</h2>
          <button className="close-btn" onClick={onClose}>
            <span>&times;</span>
          </button>
        </div>
        
        <div className="print-preview-content">
          <div className="print-preview-info">
            <p>아래와 같이 지방이 출력됩니다. 확인 후 출력 버튼을 클릭하세요.</p>
          </div>
          
          <div className="print-preview-orientation">
            <label htmlFor="orientation-select">용지 방향:</label>
            <select 
              id="orientation-select"
              value={orientation} 
              onChange={(e) => setOrientation(e.target.value)}
              className="orientation-select"
            >
              <option value="landscape">가로 (Landscape)</option>
              <option value="portrait">세로 (Portrait)</option>
            </select>
          </div>
          
          <div className="print-preview-tablets">
            {printData && generateTablets(printData.goin, printData.positionHanja, printData.lastnameHanja)}
          </div>
        </div>
        
        <div className="print-preview-footer">
          <button className="btn-secondary" onClick={onClose}>
            취소
          </button>
          <button 
            className="btn-primary" 
            onClick={handlePrint}
            disabled={isLoading}
          >
            {isLoading ? '출력 중...' : '출력하기'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrintPreviewModal;
